"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx6 = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _commonRichText = require("@mmc/common-rich-text");
var _text = require("@mmc/text");
var _fiftyFifty = require("./fifty-fifty.propTypes");
var _textBoxWithImage = _interopRequireDefault(require("./text-box-with-image.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;

/**
 * ## HalfText - component
 *
 * This sub-component of Fiftyfifty component is to display formatted text block.
 */

var eventHandler = function eventHandler(link, labelComp, mksSectionName) {
  var _window, _window$dataLayer;
  var modelName = '';
  if (window.location && window.location.pathname) {
    var pathnames = window.location.pathname.split('/');
    var pathnamePosition = pathnames.length >= 3 ? 2 : 1;
    // eslint-disable-next-line prefer-destructuring
    modelName = pathnames[pathnamePosition];
  }
  (_window = window) == null ? void 0 : (_window$dataLayer = _window.dataLayer) == null ? void 0 : _window$dataLayer.push({
    event: 'linkclickevent',
    section_name: mksSectionName,
    component: 'Text with Image',
    action: 'CTA click',
    click_text: link.label,
    nameplate: modelName
  });
};
var HalfText = function HalfText(_ref) {
  var _clsx, _clsx2, _clsx3, _clsx4, _clsx5;
  var data = _ref.data,
    theme = _ref.theme,
    disclaimerData = _ref.disclaimerData,
    hasText = _ref.hasText;
  var cta = handleNestedProp(data, 'data.cta');
  var buttonPriority = cta.priority;
  var shouldRenderCta = (0, _react.useMemo)(function () {
    return !!cta.URL;
  }, [cta]);
  var isDarkTheme = data.theme === 'dark';
  var _ref2 = data || {},
    ctaObj = _ref2.cta,
    heading1 = _ref2.heading1,
    heading2 = _ref2.heading2,
    textBlock = _ref2.textBlock,
    mksSectionName = _ref2.mksSectionName;
  console.log();
  var hasOnlyCta = function hasOnlyCta() {
    return !hasText && !heading2 && !!(ctaObj != null && ctaObj.label);
  };
  var hasOnlyLabel = function hasOnlyLabel() {
    return !hasText && !heading2 && !!heading1;
  };
  var getIsJustifyCenter = function getIsJustifyCenter() {
    var hasOnlyHeading = !hasText && !!heading2;
    var hasOnlyBodyText = hasText && !heading2;
    return !!(hasOnlyHeading || hasOnlyBodyText || hasOnlyCta() || hasOnlyLabel());
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_textBoxWithImage["default"].textBlockWrap, (_clsx = {}, _clsx[theme.dark] = isDarkTheme, _clsx[_textBoxWithImage["default"].justifyFlexEnd_desktop] = data.carAlignment === 'right' && !getIsJustifyCenter(), _clsx[_textBoxWithImage["default"].justifyCenter] = getIsJustifyCenter(), _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])((_clsx2 = {}, _clsx2[_textBoxWithImage["default"].smallTextBlock] = data.size === 'small', _clsx2[_textBoxWithImage["default"].notSmallTextBlock] = data.size !== 'small', _clsx2))
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: heading1,
    className: (0, _clsx6["default"])(_textBoxWithImage["default"].marginBottom16, theme.labelMedium, (_clsx3 = {}, _clsx3[_textBoxWithImage["default"].whiteButtons] = isDarkTheme, _clsx3), _textBoxWithImage["default"].heading),
    tag: "h2",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: (0, _clsx6["default"])(theme.headingTwo, _textBoxWithImage["default"].heading2, (_clsx4 = {}, _clsx4[_textBoxWithImage["default"].whiteButtons] = isDarkTheme, _clsx4)),
    text: heading2,
    tag: data.headingTag || 'h3',
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(theme.bodyCopy, (_clsx5 = {}, _clsx5[_textBoxWithImage["default"].whiteButtons] = isDarkTheme, _clsx5[_textBoxWithImage["default"].marginBottom24] = shouldRenderCta, _clsx5), _textBoxWithImage["default"].heading)
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      format: null,
      html: textBlock,
      tagName: "p"
    }),
    disclaimerData: disclaimerData
  })), shouldRenderCta && /*#__PURE__*/_react["default"].createElement("div", {
    className: _textBoxWithImage["default"].textBoxImageButton + " " + (buttonPriority === 'critical' ? _textBoxWithImage["default"].critical : '')
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    className: "textBoxImageButton",
    data: cta,
    "data-section": heading1,
    theme: theme,
    mouseDownEvent: function mouseDownEvent() {
      return eventHandler(cta, heading1, mksSectionName);
    }
  }))));
};
HalfText.displayName = 'HalfText';
var _default = HalfText;
exports["default"] = _default;